import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment-timezone';

import { EProfileBillingStatus } from '../../../interfaces/professionalprofile.interface';

@Component({
	selector: 'app-billing-card',
	templateUrl: './billing-card.component.html',
	styleUrls: ['./billing-card.component.scss'],
})
export class BillingCardComponent implements OnInit {
	@Input() businessType: 'natural' | 'legal';
	@Input() selected: boolean;
	@Input() active: boolean;
	@Input() stage: EProfileBillingStatus;
	@Input() activationDate: string;
	@Input() inactivationDate: string;
	@Output() cardSelected: EventEmitter<void> = new EventEmitter<void>();
	@Output() cardActivated: EventEmitter<void> = new EventEmitter<void>();
	@Output() cancel: EventEmitter<void> = new EventEmitter<void>();
	public stages = EProfileBillingStatus;
	constructor(
		public translateService: TranslateService,
		private datePipe: DatePipe
	) {}

	ngOnInit(): void {
		if (this.stage === undefined) {
			this.setInitialStage();
		}
	}

	onSelect(event: MouseEvent) {
		event.stopPropagation();
		this.cardSelected.emit();
		this.cardActivated.emit();
	}

	onRequestCancel(event: MouseEvent) {
		event.stopPropagation();
		this.cancel.emit();
	}

	stageMessage(): string {
		const { WaitingChange, Active, Inactive } = EProfileBillingStatus;
		if ([WaitingChange, Active, Inactive].includes(this.stage)) {
			return this.translateService.instant(this.getTranslateMessage(), {
				date: this.getDescriptionDate(),
			});
		}
		return this.translateService.instant(this.getTranslateMessage());
	}

	private setInitialStage() {
		if (this.selected) {
			this.stage = EProfileBillingStatus.Active;
		} else {
			this.stage = EProfileBillingStatus.Blank;
		}
	}

	private getDescriptionDate() {
		if (this.stage == EProfileBillingStatus.Inactive) {
			let date = new Date().toISOString();
			if (this.inactivationDate) {
				date = moment(this.inactivationDate).add(1, 'day').toISOString();
			}
			return this.datePipe.transform(date, "dd/MM/yyyy 'às' HH:mm");
		} else if (this.stage == EProfileBillingStatus.WaitingChange) {
			return this.datePipe.transform(
				this.activationDate || new Date().toISOString(),
				'dd/MM/yyyy'
			);
		}
		return this.datePipe.transform(
			this.activationDate || new Date().toISOString(),
			"dd/MM/yy 'às' HH:mm"
		);
	}

	private getTranslateMessage(): string {
		const translatePath = `MY_ACCOUNT.FINANCIAL.BILLING_CARD.DESCRIPTION.${
			this.businessType === 'natural' ? 'PERSONAL' : 'LEGAL_ENTITY'
		}`;
		switch (this.stage) {
			case EProfileBillingStatus.WaitingApproval:
				return translatePath + '.PENDING';
			case EProfileBillingStatus.Blank:
				return translatePath + '.BLANK';
			case EProfileBillingStatus.Active:
				return translatePath + '.ACTIVE';
			case EProfileBillingStatus.InProgress:
				return translatePath + '.IN_PROGRESS';
			case EProfileBillingStatus.RequestingChange:
				return translatePath + '.REQUESTING_CHANGE';
			case EProfileBillingStatus.WaitingChange:
				return translatePath + '.WAITING_CHANGE';
			case EProfileBillingStatus.Inactive:
				return translatePath + '.INACTIVATED_IN';
			case EProfileBillingStatus.UpdateRequested:
				return translatePath + '.PENDING';
		}
	}

	showCancelButton() {
		const { RequestingChange } = this.stages;
		return [RequestingChange].includes(this.stage);
	}
}
